import { useEffect } from "react";

export function useSubscription(source, observer = undefined) {
  useEffect(() => {
    const subscription = source.subscribe(observer);
    return () => {
      subscription.unsubscribe();
    };
  }, [source]);
}
